<template>
	<div>
		<div class="card">
			<div class="image-container higher">
				<img class="card-img-top" :src="meal_image_url" alt="Food Image">
			</div>
			<div class="card-body">
				<div class="d-flex justify-content-between">
					<label class="higher meal-name"><em>{{meal.nameShort}}</em></label>
				</div>
				<p class="higher">{{convert_time(meal.mealTime)}}</p>
				<div class="card-text">
					<!--<button class="btn btn-primary col-12" v-on:click.prevent="toggle_info">Show Meal Information</button>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'meal-item-preview',
		props: ['meal', 'meals', 'hideLiking'],
		data() {
			return {
				swap: null,
				show_info: false,
				loading: false
			};
		},
		computed: {
			cutoff_times() {
				return this.$store.getters.get_cutoffs;
			},
			meal_time() {
				return this.meal.mealTime;
			},
			meal_image_url() {
				return this.meal.imageUrl != null ? this.meal.imageUrl : '//s3.us-east-2.amazonaws.com/hflm-assets-dev/meal_3.jpg';
			}
		},
		mounted() {
		},
		updated() {
		},
		methods: {
			toggle_info() {
				this.show_info === true ? this.show_info = false : this.show_info = true;
				this.already_subbed = false;
				this.reveal_swap = false;
			},
			hide_info() {
				this.show_info = false;
			},
			hide_options() {
				this.reveal_swap = false;
			},
			convert_time(time) {
				switch (time) {
					case 0:
						return 'Breakfast';
					case 1:
						return 'Lunch';
					case 2:
						return 'Dinner';
				}
			}
		}
	};

</script>

<style scoped lang="scss">
	@import '../../styles/scss/colors';

	.swap-overlay {
		overflow-y: scroll;
	}

	.card-text {
		font-weight: 100;
	}

	.card {
		box-shadow: 1px 1px 1px 1px $light-silver;
		height: 100%
	}

	.icon {
		color: $grey;
		height: 30px;
		width: 30px;
		&:hover {
			cursor: pointer;
		}
	}

	.swap-meal {
		text-align: center;
		color: #222;
		font-weight: 200;
		padding-top: 25%;
		padding-left: 5%;
		padding-right: 5%;
		position: absolute;
		top: 0;
	}

	.card-body {
		width: 100%;
		bottom: 0;
		padding: 6%;
		label {
			font-size: 18px;
			color: $grey;
			font-weight: 600;
			line-height: 25px;
		}
	}

	.swap {
		position: relative;
		top: 10px;
	}

	.swap-text {
		margin-left: 10px;
	}

	.liked {
		color: $red;
	}

	.replaced {
		color: $grey;
		font-weight: 100;
	}

	.image-container {
		position: relative;
		width: 100%;
		padding-bottom: 75%;
		background-color: $purple-background-2;
		display: inline-table;
	}

	.card-img-top {
		position: absolute;
		width: 100%;
        object-fit: cover;
	}


	.liked-container {
		position: absolute;
		top: 5px;
		right: 25px;
	}

	.swapped-container {
		position: absolute;
		top: 5px;
		left: 15px;
	}

	.edit {
		position: absolute;
		z-index: 700;
		bottom: -10px;
		right: 0;
		color: $light-silver;
		height: 200px;
		width: 200px;
		transform: rotate(35deg);
	}

	.higher {
		position: relative;
		z-index: 999;
	}

	.subbed-overlay {
		padding: 2%;
		box-shadow: 5px 5px 5px 5px $silver;
		position: absolute;
		border-radius: 5px 5px 0 0;
		top: 0;
		background: rgba(0, 0, 0, 0.6);
		color: white;
		font-weight: 400;
		width: 100%;
		height: 100%;
		overflow-y: hidden;
		overflow-x: hidden;
		h2 {
			color: $silver;
		}
		p {
			width: 75%;
			padding: 6px;
			border-radius: 5px;
		}
		.sub-option {
			background: rgba(0, 0, 0, 0.2);
			cursor: pointer;
			color: white;
			font-style: italic;
		}
		.exit {
			&:hover {
				cursor: pointer;
			}
		}
	}

	.button-10 {
		color: white !important;
		border: 1px solid white !important;
	}

	.btn {
		max-height: 38px;
		min-height: 30px;
	}

	.white {
		color: white;
	}


</style>
<style lang="scss">
	@import '../../styles/scss/colors';

	.no-opacity {
		opacity: 0;
		background: rgba(0, 0, 0, 0.7) !important;
	}

	.opacity {
		opacity: 1 !important;
	}

	.swap-success {
		right: 15px;
		bottom: 0;
		font-size: 20px;
		font-weight: bold;
		color: $green;
		font-style: italic;
		background: rgba(0, 0, 0, 0.6) !important;
		border-radius: 5px;
		height: 45px;
		padding: 12px;
	}

	.past-swap {
		color: #E83E8C;
	}

</style>
